export type PageItem = number | "...";

interface Args {
  current: number;
  total: number;
  marginPages?: number;
  range?: number;
}

export function computeVisiblePages({
  current,
  total,
  marginPages = 1,
  range = 3,
}: Args): PageItem[] {
  if (total <= 0) return [];
  if (total <= marginPages * 2 + range + 2) {
    return Array.from({ length: total }, (_, i) => i);
  }

  const half = Math.floor(range / 2);
  const left = Math.max(marginPages, current - half);
  const right = Math.min(total - 1 - marginPages, current + half);

  const pages: PageItem[] = [];

  for (let i = 0; i < marginPages; i++) pages.push(i);
  if (left > marginPages) pages.push("...");
  for (let i = left; i <= right; i++) pages.push(i);
  if (right < total - 1 - marginPages) pages.push("...");
  for (let i = total - marginPages; i < total; i++) pages.push(i);

  return pages;
}
